// Code-native corner geometry shared by the browser and TV implementations.
export const PREMIUM_PANEL_OUTER = "M32 2H11L9 6H6V9L2 11V32";
export const PREMIUM_PANEL_INNER = "M32 6H14L12 10H10V12L6 14V32";
export const PREMIUM_OUTER = "M48 2H21C9 2 2 9 2 21V48";
export const PREMIUM_INNER = "M48 7H22C12 7 7 12 7 22V48";
export const PREMIUM_ENGRAVING =
  "M43 4H26C14 4 4 14 4 26V43M27 7C19 6 10 9 9 16C7 22 12 24 15 21C18 18 14 14 11 17M7 28L11 32L7 36M28 7L32 11L36 7";
export const CLASSIC_CORNER_CAP =
  "M48 0H19C7 0 0 7 0 19V48H17V35C17 25 25 17 35 17H48Z";
